export type PostedFilterMode = 'all' | 'posted' | 'unposted';

export interface PostedFilterOption {
	label: string;
	value: PostedFilterMode;
}

export const POSTED_FILTER_OPTIONS: PostedFilterOption[] = [
	{ label: 'All', value: 'all' },
	{ label: 'Posted only', value: 'posted' },
	{ label: 'Unposted only', value: 'unposted' }
];
